import React from 'react';

export const useClickMenu = () => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);

  const toggle = React.useCallback((event: React.MouseEvent<HTMLElement>) => {
    const trigger = event.currentTarget;
    setAnchorEl((prev) => (prev ? null : trigger));
  }, []);

  const close = React.useCallback(() => setAnchorEl(null), []);

  return { open: Boolean(anchorEl), anchorEl, toggle, close };
};
